import { VibeCheckOptionIdType } from '../types';
import { VIBE_CHECK_OPTIONS } from '../VIBE_CHECK_OPTIONS';

const DEFAULT_ID: VibeCheckOptionIdType = 'tender_soft';
const DEFAULT_TITLE = VIBE_CHECK_OPTIONS[1].title; // tender_soft option

export const getVibeCheckChoiceIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): VibeCheckOptionIdType | null => {
  const id = VIBE_CHECK_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getVibeCheckChoiceTitleById = (
  id: VibeCheckOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = VIBE_CHECK_OPTIONS.find((option) => option.id === id)?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
